module.exports = __webpack_public_path__ + "static/media/badge-pre-order-apple.08f7e532.svg";